import { ClassNameProps } from "@/types";

enum LockedSashSize {
  Small = "small",
  Medium = "medium",
  Large = "large",
  XLarge = "xlarge",
}

interface LockedSashProps
  extends ClassNameProps,
    React.HTMLAttributes<HTMLDivElement> {
  size: LockedSashSize;
}

export { LockedSashSize };
export type { LockedSashProps };
